import cx from 'classnames';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';

import { modalWindowPopstate } from '@app/store/modal/actions';
import { getActiveModals } from '@app/store/modal/selectors';

import MODAL_COMPONENTS from './modals';

import './RootModal.scss';

const propTypes = {
  modals: PropTypes.arrayOf(
    PropTypes.shape({
      modalType: PropTypes.string,
      modalProps: PropTypes.object,
    })
  ),
  onModalWindowPopstate: PropTypes.func,
};

const defaultProps = {
  modals: [],
  onModalWindowPopstate() {},
};

class RootModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prevPropsModalLength: props.modals.length,
      prevIsClosed: false,
    };
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    const { modals } = props;
    const { prevPropsModalLength } = state;

    if (modals.length > prevPropsModalLength) {
      return {
        prevPropsModalLength: modals.length,
        prevIsClosed: false,
      };
    }
    if (modals.length < prevPropsModalLength) {
      return {
        prevPropsModalLength: modals.length,
        prevIsClosed: true,
      };
    }
    return null;
  }

  componentDidMount() {
    window.addEventListener('popstate', this.handleModalClose);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handleModalClose);
  }

  handleModalClose() {
    const { modals, onModalWindowPopstate } = this.props;

    const pageLeavePreventionModals = modals.filter((modal) => {
      const { modalProps } = modal;
      return modalProps.isPageLeavePrevention;
    });
    if (pageLeavePreventionModals.length === 0) {
      onModalWindowPopstate();
    }
  }

  render() {
    const { modals } = this.props;
    const { prevIsClosed } = this.state;

    if (modals.length === 0) {
      return null;
    }

    return (
      <div className="RootModal">
        {modals.map((modal, key) => {
          const { modalType, modalProps } = modal;
          const SpecificModal = MODAL_COMPONENTS[modalType];

          const overlayClassName = cx({
            Overlay: true,
            'RootModal__overlay--on-one-modal': modals.length === 1,
            'RootModal__overlay--1st-on-double-modal': modals.length === 2 && key === 0,
            'RootModal__overlay--2st-on-double-modal': modals.length === 2 && key === 1,
            'RootModal__overlay--1st-on-triple-modal': modals.length === 3 && key === 0,
            'RootModal__overlay--2st-on-triple-modal': modals.length === 3 && key === 1,
            'RootModal__overlay--3st-on-triple-modal': modals.length === 3 && key === 2,
            'RootModal__overlay--from-closed': prevIsClosed,
          });

          return (
            <ReactModal
              bodyOpenClassName="RootModal__Body--open"
              className="RootModal__content"
              contentLabel="Modal"
              isOpen
              key={key} // eslint-disable-line react/no-array-index-key
              overlayClassName={overlayClassName}
            >
              <SpecificModal {...modalProps} />
            </ReactModal>
          );
        })}
      </div>
    );
  }
}

RootModal.propTypes = propTypes;
RootModal.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  modals: getActiveModals(state),
});

const mapDispatchToProps = {
  onModalWindowPopstate: modalWindowPopstate,
};

export default connect(mapStateToProps, mapDispatchToProps)(RootModal);
